import serverOptimized from '@nykaa/nes-utils/serverOptimized';

export default serverOptimized(
  () => import(/* webpackChunkName: "shoppingBag.m" */ './Loadable'),
  ''
);
